import {createContext, useContext} from 'react'

type ChecklistFormMeta = {
  plantId: string
}

const ChecklistFormMetaContext = createContext<ChecklistFormMeta | null>(null)

export const useChecklistFormMeta = (): ChecklistFormMeta => {
  const context = useContext(ChecklistFormMetaContext)
  if (!context) {
    throw new Error('useChecklistFormMeta must be used within a ChecklistFormMetaProvider')
  }
  return context
}

export const ChecklistFormMetaProvider = ChecklistFormMetaContext.Provider
